import { Box, Stack, Typography } from '@mui/material';
import logo from '../../assets/images/logo.webp';
import { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { LoginForm } from './LoginForm';
import { OTPForm } from './OTPForm';
import { LoginMessage } from './LoginMessage';
import { BannerData } from '../../types/common.type';
// import CommonServices from '../../services/common.services';
import welcomeBanner from '../../assets/images/banner.jpg';

export default function Login() {
  const [otpSent, setOtpSent] = useState(false);
  const [images, setImages] = useState<BannerData[]>([]);
  const [mobileNumber, setMobileNumber] = useState('');
  const [loginStarted, setLoginStarted] = useState(true);
  const { width, height } = { width: window.innerWidth, height: window.innerHeight };
  const [showTextIndex, setShowTextIndex] = useState(0);

  useEffect(() => {
    setImages([
      {
        id: '1',
        imgUrl: welcomeBanner,
        imageType: 'HOMESCREEN',
        imageCat: 'BANNER',
      },
    ]);
  }, []);

  useEffect(() => {
    let interval = setInterval(() => {
      setShowTextIndex((x) => (x + 1) % images.length);
    }, 2000);
    let interval2 = setInterval(() => {}, 50);

    return () => {
      clearInterval(interval);
      clearInterval(interval2);
    };
  }, [images.length]);

  const showCss = 'transition-all duration-500 delay-1000  opacity-100',
    hideCss = 'transition-all duration-500 delay-1000  opacity-0',
    imageCss = 'fixed top-12 left-0 w-full h-[80%] object-cover object-center ';

  return (
    <Stack display={'flex'} flexDirection={'column'} flex={1} justifyContent={'end'}>
      <div>
        <img className={imageCss + showCss} src={welcomeBanner} alt="a" />
      </div>
      <Box className="fixed top-0 left-0 w-full h-full " />
      <div
        style={{
          backgroundImage: 'linear-gradient(#fff, #fff, #fff, #fff, #fff,  transparent)',
        }}
        className="  gap-1 flex flex-col fixed top-0 left-0 w-full px-3 py-5 pb-12"
      >
        <img alt="IFB" src={logo} className={'self-start h-7 object-contain'} />

        <Typography className={showTextIndex === 1 ? showCss : hideCss}>
          Inspiring Happiness for 50 years!
        </Typography>
        <Typography className={showTextIndex === 0 ? showCss : hideCss} mt={-3.7} fontSize={18}>
          Serving 9 million customers!
        </Typography>
      </div>
      <Stack
        zIndex={2}
        p={2}
        pt={10}
        gap={3}
        className="fixed bottom-0 left-0 w-full"
        sx={{
          backgroundImage: 'linear-gradient(transparent, #fff,  #fff, #fff, #fff )',
        }}
      >
        {!loginStarted ? (
          <LoginMessage setLoginStarted={setLoginStarted} />
        ) : otpSent ? (
          <OTPForm number={mobileNumber} />
        ) : (
          <LoginForm
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            setOtpSent={setOtpSent}
          />
        )}
      </Stack>
      <Confetti
        confettiSource={{ x: 0, y: height, w: width, h: 0 }}
        numberOfPieces={100}
        gravity={0.2}
        initialVelocityY={10}
        initialVelocityX={1}
        friction={1}
        recycle={false}
        style={{ zIndex: 99999 }}
      />
    </Stack>
  );
}
